import ProgramSession from 'models/ProgramSession';

const SUN = 'SUN';
const MON = 'MON';
const TUE = 'TUE';
const WED = 'WED';
const THU = 'THU';
const FRI = 'FRI';
const SAT = 'SAT';
const days = [SUN, MON, TUE, WED, THU, FRI, SAT] as const;

export type TimePeriod = {
  am?: boolean;
  pm?: boolean;
};

type Schedule = {
  [day in typeof days[number]]?: TimePeriod;
};

// transforms
// { { "TUE": { "am": true, "pm": true } }
// into
// [ { "day_index": 1, "order_index": 0 }, { "day_index": 1, "order_index": 1 } ]

export const programsDefaultSchedule: Schedule = {
  MON: { am: true, pm: true },
  TUE: { am: true, pm: true },
  WED: { am: true, pm: true },
  THU: { am: true, pm: true },
  FRI: { am: true, pm: true }
};

export const scheduleToProgramSessions = (schedule: Schedule) => {
  return Object.entries(schedule).flatMap(([day, period]) => {
    return Object.entries(period)
      .filter(([, bool]) => bool)
      ?.flatMap(([time]) => {
        return {
          day_index: days.indexOf(day as typeof days[number]),
          order_index: time == 'am' ? 0 : 1
        };
      });
  });
};

export const programSessionsToSchedule = (programSessions: ProgramSession[]) => {
  const schedule: Schedule = {
    MON: {
      am: false,
      pm: false
    },
    TUE: {
      am: false,
      pm: false
    },
    WED: {
      am: false,
      pm: false
    },
    THU: {
      am: false,
      pm: false
    },
    FRI: {
      am: false,
      pm: false
    },
    SAT: {
      am: false,
      pm: false
    },
    SUN: {
      am: false,
      pm: false
    }
  };

  programSessions.forEach(({ day_index, order_index }) => {
    const day = days[day_index || 0];
    if (day && schedule[day]) {
      if (order_index === 0) {
        schedule[day].am = true;
      } else if (order_index === 1) {
        schedule[day].pm = true;
      }
    }
  });

  return schedule;
};
